import React from 'react';
import "./terms.css";
import {getColor} from "../../utilities/getColor";



const Terms = (
  {
    terms,
    title,
    primary,
    searchValue,
    searchChange,
    index
  }
) => {
  return (
    <div className="terms_container">
      <div className="terms_container__primary">
        <span>{title}</span>
      </div>

      <div className="terms_container__terms">
        {
          terms.map((term, i) => (
            <div
              key={i}
              className="terms_container__terms__term"
              style={{backgroundColor: getColor({
                primary: primary,
                sentiment: !primary,
                fromd3: false,
                d: {
                  sentiment: title,
                  primary: title
                }
              })}}
            >
              <span>{term}</span>
            </div>
          ))
        }
      </div>

  </div>
  )
};


export default Terms;



// WEBPACK FOOTER //
// ./src/components/terms/terms-component.js